import React from 'react';
import { useNavigate } from 'react-router-dom';
import  "./ShortcutButton.css";
import { TiHomeOutline } from "react-icons/ti";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";

import { FiPhoneCall } from "react-icons/fi";



const ShortcutButton = () => {
    const navigate = useNavigate();

    const handleDashboardClick = () => {
        localStorage.setItem('activeLinkId', "1");
        localStorage.setItem('dropedownid', "[]");
        navigate('/dashboard'); 
    };
    const handleChat = () => {
        navigate('/chatwithus'); 
    };
    const handleCall = () => {
        navigate('/callus'); 
    };

    const [buttonClass, setButtonClass] = React.useState('movingButton');

    const handleClass = (e) => {
        e.preventDefault();
        setButtonClass(prevClass => prevClass === 'clickedClass' ? 'movingButton' : 'clickedClass');
        console.log('clicked');
    };

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.movingButton') && !event.target.closest('.clickedClass')) {
                setButtonClass('movingButton');
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <button 
            className={buttonClass} 
            onClick={handleClass}
        >
            <div className='iconBG'><TiHomeOutline {...(buttonClass === 'clickedClass' && { onClick: handleDashboardClick })}/></div>
            {buttonClass === 'clickedClass' && <div className='iconBG'><IoChatbubbleEllipsesOutline onClick={handleChat} /></div>}
            {buttonClass === 'clickedClass' && <div className='iconBG'><FiPhoneCall onClick={handleCall} /></div>}
        </button>
    )
};

export default ShortcutButton;

